import React from 'react';
import styles from './styles.module.scss';

interface HeaderActionButtonProps {
  onClick?: () => void;
  /** Optional icomoon icon name (rendered as `icon-{name}`) */
  icon?: string;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
  'data-testid'?: string;
}

/**
 * Compact accent-coloured action button used in MainSection's `headerRight` slot
 * on mobile (e.g. "Create" on tournaments list, "Invite" on participants tab).
 */
export const HeaderActionButton: React.FC<HeaderActionButtonProps> = ({
  onClick,
  icon,
  children,
  className,
  type = 'button',
  'data-testid': testId,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${styles.button} ${className || ''}`}
      data-testid={testId}
    >
      {icon && <i className={`icon icon-${icon}`} />}
      {children}
    </button>
  );
};

export default HeaderActionButton;
